import fetcher from "../src/fetcher";
import consumer from "./consumer";

type Params = {
  type: "logout";
};

consumer.subscriptions.create("UserChannel", {
  initialized() {
    console.info("Connected to the UserChannel!");
    document.addEventListener("heartbeat", (event) => {
      this.heartbeat(event.detail);
    });
  },

  received: async (params: Params) => {
    if (params.type === "logout") {
      await fetcher("/users/sign-out", {
        method: "DELETE",
        body: {
          type: "blocked",
        },
      });
      window.location.href = "/";
    }
  },

  heartbeat(data) {
    this.perform("heartbeat", data);
  },
});
